<template>
    <div>
        <b-breadcrumb :items="items"/>
        <div class="container-fluid text-center" style="background-color: white;">
            <br />
            <div class="col-sm-10 col-xs-12 text-center">
                <!--<div class="form-group row">-->
                    <!--<label class="col-sm-4 col-form-label text-capitalize text-right">-->
                        <!--กรณีสินค้าแผงตัวอย่าง-->
                    <!--</label>-->
                    <!--<div class="col-sm-6 form-check-inline">-->
                        <!--<div class="form-check">-->
                            <!--<input type="radio" class="form-check-input"-->
                                   <!--v-model="form.special_product"-->
                                   <!--value="1" id="special_customer_yes">-->
                            <!--<label class="form-check-label" for="special_customer_yes">ใช่</label>-->
                        <!--</div>-->
                        <!--<div class="form-check">-->
                            <!--<input type="radio" class="form-check-input"-->
                                   <!--v-model="form.special_product"-->
                                   <!--value="0" id="special_customer_no">-->
                            <!--<label class="form-check-label" for="special_customer_no">ไม่ใช่</label>-->
                        <!--</div>-->
                    <!--</div>-->
                <!--</div>-->
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label text-capitalize text-right">
                        รหัสสินค้า
                    </label>
                    <div class="col-sm-6">
                        <input type="text"
                               placeholder="เช่น 109 , 501 ,..."
                               class="form-control"
                               v-model="form.code"/>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label text-capitalize text-right">
                        ประเภทสินค้า
                    </label>
                    <div class="col-sm-6">
                        <multiselect
                                v-model="form.product_type"
                                :options="optionProductType"
                                track-by="id"
                                :show-labels="false"
                                :custom-label="LabelName"
                                placeholder="เลือกประเภทสินค้า">
                        </multiselect>
                    </div>
                </div>
                <!--v-if="form.product_type.id == โฟม"-->
                <div class="form-group row" v-if="form.product_type && form.product_type.id == type_form">
                    <label class="col-sm-4 col-form-label text-capitalize text-right">
                        ขนาดสินค้า (โฟม)
                    </label>
                    <div class="col-sm-6">
                        <b-form-select v-model="form.size_form_id"
                                       :options="sizeProduct">
                        </b-form-select>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label text-capitalize text-right">
                        แพ็ค
                    </label>
                    <div class="col-sm-6">
                        <multiselect
                                v-model="form.pack"
                                :options="optionPack"
                                track-by="id"
                                :show-labels="false"
                                label="number"
                                placeholder="เลือกแพ็คสินค้า">
                        </multiselect>
                    </div>
                    <div class="col-sm-2 form-button" v-if="canViewSuperAdmin">
                        <button class="btn btn-success"
                                @click="showModalAddPack"
                                style="font-size: 14px">
                                <icon name="save" style="width: 15px"></icon>
                            จัดการ แพ็ค</button>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label text-capitalize text-right">
                        หน่วยสินค้าที่ใช้คำนวณค่าขนส่ง (ถ้ามี)
                    </label>
                    <div class="col-sm-6">
                        <b-form-select v-model="form.unit_quantity"
                                       :options="unit_quantity">
                        </b-form-select>
                    </div>
                </div>
                <!--v-if=form.product_type.id == หลอด ช้อน-->
                <template v-if="form.product_type">
                    <div class="form-group row" v-if="form.unit_quantity == 2">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            จำนวนแพ็ค (<span>{{form.product_type.name}}</span>)
                        </label>
                        <div class="col-sm-6">
                            <input type="number" class="form-control"
                                   v-model="form.quantity_pack"/>
                        </div>
                        <div class="col-sm-2">
                            <span>แพ็ค / ลูก</span>
                        </div>
                    </div>
                </template>
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label text-capitalize text-right">
                        ชื่อสินค้า
                    </label>
                    <div class="col-sm-6">
                        <input placeholder="จานโฟม"
                               type="text"
                               class="form-control"
                               v-model="form.name"/>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label text-capitalize text-right">
                        ชื่อเล่น
                    </label>
                    <div class="col-sm-6">
                        <input placeholder="ชื่อเล่นสินค้า"
                               type="text"
                               class="form-control"
                               v-model="form.short_name"/>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label text-capitalize text-right">
                        จำนวน
                    </label>
                    <div class="col-sm-6">
                        <input
                                type="number"
                                class="form-control"
                                v-model="form.quantity" disabled/>
                    </div>
                </div>
                <template v-if="canInventoryProductsPriceView">
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            ราคาขาย/หน่วย
                        </label>
                        <div class="col-sm-6">
                            <input
                                    type="number"
                                    class="form-control"
                                    v-model="form.price"/>
                        </div>
                    </div>
                </template>
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label text-capitalize text-right">
                        จำนวนขั้นต่ำ
                    </label>
                    <div class="col-sm-6">
                        <input
                                type="number"
                                class="form-control"
                                v-model="form.min_quantity"/>
                    </div>
                </div>
                <div class="form-group row" v-if="canViewSuperAdmin">
                    <label class="col-sm-4 col-form-label text-capitalize text-right">
                        ค่าคอมรายสินค้า
                    </label>
                    <div class="col-sm-6">
                        <input
                            type="number"
                            class="form-control"
                            v-model="form.commission"/>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label text-capitalize text-right">
                        เลือกวัตถุดิบ(หากสินค้านี้เป็นวัตถุดิบด้วย)
                    </label>
                    <div class="col-sm-6">
                        <multiselect
                                v-model="form.material"
                                :options="materialOption"
                                track-by="id"
                                :show-labels="false"
                                :customLabel="LabelMaterialName"
                                placeholder="เลือกวัตถุดิบที่เป็นรายการสินค้า">
                        </multiselect>
                    </div>
                </div>
                <b-form inline>
                    <label class="col-4" />
                    <div class="col-sm-6 form-button" style="padding-left: 30px;">
                        <b-button :disabled="form.onSave"
                                variant="success"
                                  @click="saveProductForm">
                            <icon name="save" style="width: 25px"></icon>
                            บันทึก
                        </b-button>
                        &nbsp;&nbsp;
                        <b-button class="btn btn-outline-secondary"
                                  @click="goToProductsList">
                            <icon name="times" style="width: 25px"></icon>
                            ยกเลิก
                        </b-button>
                        &nbsp;&nbsp;
                        <b-button variant="danger"
                                  v-if="id && !form.cancel_status"
                                  @click="showModalDelete(id)">
                            <icon name="trash-alt" style="width: 25px"></icon>
                            InActive
                        </b-button>

                        <b-button variant="success"
                                  v-else-if="id && form.cancel_status"
                                  @click="showModalDelete(id)">
                            Active
                        </b-button>

                    </div>
                </b-form>
                <br/>
            </div>
            <!-- Modal -->
            <b-modal hide-header hide-footer ref="delete_item">
                <div style="text-align: center;">
                    <h4>คุณต้องการเปลี่ยนสถานะใช่ไหม?</h4>
                    <br />
                    <button @click="deleteData"
                            type="button"
                            class="btn btn-success">
                        ตกลง
                    </button>
                    &nbsp&nbsp
                    <button @click="hideModalDelete"
                            type="button"
                            class="btn btn-secondary">
                        ยกเลิก
                    </button>
                </div>
            </b-modal>
            <!-- Modal showModalAddPack -->
            <b-modal hide-header hide-footer ref="add_pack">
                <div style="text-align: center;">
                    <div>
                        <label style="color: red;font-size: 14px">**กรอกจำนวนที่ต้องการเพิ่ม/ลบ</label><br/>
                        <label style="color: red;font-size: 14px">**เช่น ต้องการลบแพ็ค DD500 ให้ใส่จำนวน DD500 แล้วกดลบ</label><br/>
                        <label>จำนวน</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="pack"/>
                    </div>

                    <br />
                    <button @click="addPack"
                            type="button"
                            class="btn btn-success">
                        เพิ่ม
                    </button>
                    &nbsp&nbsp
                    <button @click="deletePack"
                            type="button"
                            class="btn btn-danger">
                        ลบ
                    </button>
                    &nbsp&nbsp
                    <button @click="hideModalAddPack"
                            type="button"
                            class="btn btn-secondary">
                        ยกเลิก
                    </button>
                </div>
            </b-modal>
        </div>
        <!--<pre class="alert alert-primary">{{ form.product_type }}</pre>-->
        <!--<pre class="alert alert-success">{{ form }}</pre>-->
    </div>
</template>

<script>
import HeaderTitle from "../../HeaderTitle";
import { mapState } from "vuex";
import Multiselect from "vue-multiselect";
import {domain} from "../../../util/Constants";
import {
    canInventoryProductsPriceView,
    canViewSuperAdmin,
} from "../../../util/Permissions";

export default {
    components: { HeaderTitle, Multiselect },
    name: "products-information",
    props: {
        id: { default: null }
    },
    data() {
        return {
            materialOption : [],
            items: [
                {
                    text: "รายการสินค้า",
                    to: { name: "product-list" }
                },
                {
                    text: "เพิ่มเติม",
                    active: true
                }
            ],
            type_form : 1,
            type_glass : 2,
            type_spoon : 3,
            type_tube : 4,
            unit_quantity : [
                {
                    value: null,
                    text: "เลือกหน่วยสินค้าสำหรับค่าขนส่ง"
                },
                {
                    value: 1,
                    text: "ลัง"
                },
                {
                    value: 2,
                    text: "ลูก"
                },
                {
                    value: 3,
                    text: "แพ็ค"
                },
            ],
            radio_option : [
                { text: 'ใช่', value: 1 },
                { text: 'ไม่ใช่', value: null },
            ],
            pack : '',
        };
    },
    created() {
        if(!this.id){
            this.$store.dispatch('Products/clearFormData');
        }
        this.$store.dispatch("Machine/get");
        this.$store.dispatch('Products/getPack');
        this.$store.dispatch('ProductType/get');
        this.$store.dispatch("Common/getSizeWrapProduct");
        this.getMaterialAll();
    },
    computed: {
        canViewSuperAdmin,
        canInventoryProductsPriceView,
        ...mapState({
            user: state => {
                return state.Auth.user;
            },
            machine: state => {
                return state.Machine.data;
            },
            optionPack: state =>{
                return state.Products.pack;
            },
            optionProductType : state =>{
                return state.ProductType.data;
            },
            form : state =>{
                return state.Products.ProductForm;
            },
            validate : state =>{
                return state.Products.validate_product;
            },
            sizeProduct : state=>{
                return [
                    {
                        value: null,
                        text: "เลือกขนาดสินค้า"
                    },
                    ...state.Common.size_product.map(size => ({
                        value: size.id,
                        text: size.name
                    }))
                ];
            },
        })
    },

    methods: {
        addPack(){
            if(this.pack){
                let data = {
                    pack: this.pack
                };
                this.$store.dispatch('Material/addPack',data).then(()=>{
                    window.location.reload();
                });
            }
        },
        deletePack(){
            if(this.pack){
                let data = {
                    pack: this.pack
                }
                this.$store.dispatch('Material/deletePack',data).then(()=>{
                    window.location.reload();
                });
            }
        },
        getMaterialAll(){
            this.$store.dispatch("Material/getAll").then(res=>{
                this.materialOption = res;
            });
        },
        LabelName (option) {
            return `${option.type_code} - ${option.name}`
        },
        LabelMaterialName (option) {
            return `${option.code} - ${option.name}`
        },
        showModalDelete(id) {
            this.id = id;
            this.$refs.delete_item.show();
        },
        hideModalDelete() {
            this.$refs.delete_item.hide();
        },
        showModalAddPack() {
            this.pack = '';
            this.$refs.add_pack.show();
        },
        hideModalAddPack() {
            this.$refs.add_pack.hide();
        },
        //API
        saveProductForm(){
            if(!this.form.code){
                alert('กรุณาใส่รหัสสินค้า')
            }
            else if(!this.form.product_type){
                alert('กรุณาเลือกประเภท');
            }
            else if(!this.form.name){
                alert('กรุณาใส่ชื่อสินค้า')
            }
            else if(this.form.quantity < 0){
                alert('กรุณาใส่จำนวนให้ถูกต้อง');
                // this.form.quantity = 0;
            }
            else if(this.form.price < 0 || this.form.price == null){
                alert('กรุณาใส่ราคาขายให้ถูกต้อง');
                this.form.price = 0;
            }
            else if(this.form.min_quantity < 0){
                alert('กรุณาใส่จำนวนให้ถูกต้อง');
                this.form.min_quantity = 0;
            }
            else{
                this.form.onSave = true;
                this.$store.dispatch('Products/save',
                    {
                        id : this.id,
                        user : this.user
                    }).then(()=>{
                        if(this.validate==0) {
                            alert("สินค้าชนิดนี้มีอยู่ในคลังแล้ว กรุณากรอกชื่อสินค้าอื่น");
                        }else{
                            this.goToProductsList();
                        }
                })
            }
        },
        deleteData() {
            this.$store.dispatch("Products/delete", this.id).then(() => {
                this.$store.dispatch("Products/setProducts");
                this.hideModalDelete();
                this.goToProductsList();
            });
        },
        //function
        goToProductsList() {
            this.$router.push({ name: "product-list" })
            this.form.onSave = false;
        },
    }
};
</script>

<style scoped>
    .form-button {
        /*margin-left: 20%;*/
        display: flex;
        padding: 0;
    }
</style>
